import { render } from "./AppImageEditor.vue?vue&type=template&id=5d44248b&scoped=true"
import script from "./AppImageEditor.vue?vue&type=script&lang=js"
export * from "./AppImageEditor.vue?vue&type=script&lang=js"

import "./AppImageEditor.vue?vue&type=style&index=0&id=5d44248b&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d44248b"]])

export default __exports__